import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "chips"]

  connect() {
    this.observer = new MutationObserver(() => this.syncSelect())
    this.observer.observe(this.chipsTarget, { childList: true })
    this.syncSelect()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  add() {
    const select = this.selectTarget
    const value = select.value
    if (!value) return

    const chipId = `market-state-chip-${value}`
    if (document.getElementById(chipId)) return

    const wrapper = document.createElement("div")
    wrapper.id = chipId
    wrapper.dataset.stateValue = value
    wrapper.className = "flex-none"

    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = "market[state_codes][]"
    hidden.value = value

    wrapper.appendChild(hidden)

    const chip = document.createElement("div")
    chip.className =
      "px-4 py-2 rounded-lg justify-end items-center gap-4 inline-flex border " +
      "bg-support-dark-200 text-support-dark-700 border-support-dark-250 " +
      "hover:bg-support-dark-250 hover:text-support-dark-800 hover:border-support-dark-300 whitespace-nowrap"

    const label = document.createElement("div")
    label.className = "text-xs font-semibold font-['Neue Haas Grotesk Text Pro'] leading-[18px]"
    label.textContent = value
    label.dataset.chipLabel = true
    chip.appendChild(label)

    const dismiss = document.createElement("div")
    dismiss.className = "cursor-pointer"
    dismiss.role = "button"
    dismiss.ariaLabel = `Remove ${value}`
    dismiss.dataset.controller = "remove-element"
    dismiss.dataset.elementId = chipId
    dismiss.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>'
    chip.appendChild(dismiss)

    wrapper.appendChild(chip)
    this.chipsTarget.appendChild(wrapper)

    select.value = ""
  }

  syncSelect() {
    const selected = new Set(this.selectedValues())
    Array.from(this.selectTarget.options).forEach((opt) => {
      if (!opt.value) return
      opt.hidden = selected.has(opt.value)
    })
  }

  selectedValues() {
    return Array.from(
      this.chipsTarget.querySelectorAll('input[name="market[state_codes][]"]')
    ).map((el) => el.value)
  }
}
